package com.macrofocus.eflux.network.substation

import com.macrofocus.eflux.network.CombinedBuses
import com.macrofocus.eflux.network.logical.LogicalBusId
import org.molap.dataframe.ListDataFrameBuilder
import org.molap.dataframe.MapDataFrameBuilder
import org.molap.dataframe.column
import org.molap.dataframe.columnOf

class Substation(val logicalBusId: LogicalBusId, val buses: CombinedBuses?,
                 powerData: PowerSubstationData,
                 geometryData: GeometrySubstationData,
                 eodData: EODSubstationData
) : PowerSubstationData by powerData,
    GeometrySubstationData by geometryData,
    EODSubstationData by eodData {

    override fun toString(): String {
        return "$logicalBusId"
    }

    companion object {
        val columns = mapOf(
            "logicalBusId" to column<Substation,LogicalBusId> { logicalBusId },
            "name" to columnOf { it: Substation -> it.name },
        )

        val dataFrameBuilder: ListDataFrameBuilder<Substation, String>.() -> Unit = {
            "logicalBusId" to { logicalBusId }
            "name" to { name }
            "type" to { type }
            "baskv" to { baskv }
            "vm" to { vm }
        }
        val mapDataFrameBuilder: MapDataFrameBuilder<LogicalBusId,Substation, String>.() -> Unit = {
            "logicalBusId" to { logicalBusId }
            "name" to { name }
            "type" to { type }
            "baskv" to { baskv }
            "vm" to { vm }
        }
    }
}